import React, { Component } from 'react';
import Axios from 'axios';
import cachios from 'cachios'
import { BASE } from "../api/api";
import { Link } from 'react-router-dom'
import Header from '../header/newheader';
import Footer from '../footer/newfooter';
import TopBar from '../topbar/topbar'
import ReactHtmlParser from 'react-html-parser';
import OutsideClickHandler from 'react-outside-click-handler';
import { getName } from 'country-list'
import { List } from 'react-content-loader';
import togglearrow from '../assets/Home/togglearrow.png'
import down from '../assets/down.png'
import pageleft from '../assets/Home/pageleft.png'
import pagenoleft from '../assets/Home/pagenoleft.png'
import pagenoright from '../assets/Home/pagenoright.png'
import pageright from '../assets/Home/pageright.png'
import {
    Accordion,
    AccordionItem,
    AccordionItemTitle,
    AccordionItemBody,
} from 'react-accessible-accordion';
import search from '../assets/search.png'
import thesesimg from '../assets/thesis.jpg'
import load from '../assets/loading.gif'
import ThesisOpen from './thesisOpen';
import './thesis.css'
import Popup from 'reactjs-popup';
import Draggable from 'react-draggable';
import NewHeader from '../header/newheader';

import home from '../assets/Home/home.png'
import crumbarrow from '../assets/Home/right.png'
import NewFooter from '../footer/newfooter';
import ReactPaginate from 'react-paginate';

class Thesis extends Component {
    constructor(props) {
        super(props);
        this.state = {
            limit: 10,
            offset: localStorage.getItem('pagenum') ? JSON.parse(localStorage.getItem('pagenum')) : 0,
            next: false,
            prev: false,
            loginpopup: false,
            search: '',
            year: [""],
            id: '',
            name: '',
            searchs: '',
            yearselect: '',
            nidprop: props.match.params.nid ? props.match.params.nid : '',
            allrecords: true,
            nowyear: new Date().getFullYear(),
            title: '303dc99f-0f60-4d48-944d-d0bf3bc464cd',
            mainid: '303dc99f-0f60-4d48-944d-d0bf3bc464cd',
            show: false
        };
        console.log("xxx", props)
    }
    topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
    handleChanges = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }
    _handleKeyPress(e) {

        if (e.key === 'Enter') {
            this.searchclick(0, this.state.searchs)
        }
    }
    searchclick(id, contains) {
        this.newcall(id, contains)
    }
    //Next/previous click function
    handlePageClick = data => {
        console.log(data, 'offset')
        let dt = localStorage.getItem('token');
        if (data === 'next' && this.state.next === true) {
            // if (dt && dt != null) {
            console.log("next working")
            this.setState({
                thesis: '',
            })
            this.setState({
                offset: this.state.offset + this.state.limit
            }, () => {
                if (this.state.yearselect)
                    this.newcall(this.state.offset, this.state.yearselect, this.state.id)
                else
                    this.singletheses(this.state.id, this.state.offset)
            })
            console.log(this.state.offset, 'offset in api')
            // }
            // else {
            //     this.setState({
            //         loginpopup: true,
            //         // offset: this.state.offset + this.state.limit,
            //         pagination: true,
            //         link_redirect: false
            //     })
            // }


        }
        else if (data === 'prev' && this.state.prev === true) {
            this.setState({
                thesis: '',
            })
            this.setState({
                offset: this.state.offset - this.state.limit
            }, () => {
                if (this.state.yearselect)
                    this.newcall(this.state.offset, this.state.yearselect, this.state.id)
                else
                    this.singletheses(this.state.id, this.state.offset)
            })
        }
    };
    signout() {
        localStorage.removeItem('token');
        localStorage.removeItem('expirytime');
        localStorage.removeItem('expiryref');
        // window.location.href = '/'

    }


    refreshexp() {
        let s = new Date();
        s.setSeconds(s.getSeconds() + 1800);
        localStorage.setItem('expiryref', s)
    }


    checkexpiry() {
        if (localStorage.getItem('expiryref')) {
            let expref = Date.parse(localStorage.getItem('expiryref'))
            let s = new Date();
            if (s > expref) {
                this.signout()
            }
            else {
                this.refreshexp()
            }

        }
        else {
            this.signout()
        }
    }


    componentWillMount() {
        let i
        let year = [""]
        for (i = new Date().getFullYear(); i >= 2010; i--) {
            year.push(i)
        }
        this.setState({
            year: year,
            thesis: []
        })
        this.singletheses('303dc99f-0f60-4d48-944d-d0bf3bc464cd', 0)
        console.log(new Date().getFullYear(), "year")
        this.getfilters()
        localStorage.removeItem('pagenum')

        let dt = localStorage.getItem('token')
        if (!dt || dt == null) {
            this.setState({ login: false })

        }
        else {
            this.setState({ login: true })
        }
        // this.setState({

        //     thesis: undefined
        // })
        let nowyear = new Date().getFullYear()
    }
    getHighlightedText(text) {
        // Split on higlight term and include term into parts, ignore case
        if (this.state.search) {
            let parts = text.split(new RegExp(`(${this.state.search})`, 'gi'));
            return <div className="myspan"> {parts.map((part, i) =>
                <span key={i} style={part.toLowerCase() === this.state.search.toLowerCase() ? { backgroundColor: 'yellow', display: 'inline' } : {}}>
                    {part}
                </span>)
            } </div>;
        }
        else {
            return (text)
        }
    }

    getfilters() {
        Axios.get(BASE + 'jsonapi/taxonomy_term/programs?include=field_image&filter[display][group][conjunction]=OR&filter[title][condition][path]=field_frontend_display&filter[title][condition][value]=0&&filter[title][condition][memberOf]=display&filter[novalue][condition][path]=field_frontend_display&filter[novalue][condition][operator]=IS NULL&filter[novalue][condition][memberOf]=display')
            .then((data) => {
                console.log(data, 'programs')
                this.setState({
                    programs: data.data.data
                }, () => {
                    let i = 0
                    for (i = 0; i < data.data.data.length; i++) {
                        this.setState({
                            [`yearselect${i}`]: "year"
                        })
                    }
                })
            })
    }
    search(e) {
        this.setState({
            search: e.target.value
        })
    }
    newcall(id, contains, program) {
        console.log("newcall")
        console.log("awr-year " + contains)
        this.setState({
            search: contains,
            thesis: '',
            next: false,
            count: 0,
        })
        this.topFunction();
        //HIDE/SHOW  previous button
        if (id <= 0) {
            this.setState({
                prev: false,
            })
        }
        else {
            this.setState({
                prev: true
            })
        }

        Axios.get(BASE + 'jsonapi/node/submit_for_work?include=field_author,field_cis_program&filter[field_cis_thesis]=1&filter[titleFilter][condition][path]=field_select_work_to_submit.name&filter[titleFilter][condition][value]=Thesis&filter[program][condition][operator]=CONTAINS&filter[program][condition][path]=field_cis_program.id&filter[program][condition][value]=' + program + '&filter[year][condition][path]=field_year_of_graduation&filter[year][condition][operator]=CONTAINS&filter[year][condition][value]=' + contains + '&page[limit]=' + this.state.limit + '&page[offset]=' + id + '&sort=-created')

            .then((data) => {
                console.log(data.data.data, 'next thesis')
                this.setState({
                    thesis: data.data.data,
                    author: data.data.included,
                    count: data.data.meta ? data.data.meta.count : "",
                }, () => {
                    console.log("data updated false", data.data.meta)
                })
                if (data.data.links) {
                    this.setState({
                        next: data.data.links.next ? true : false,
                        prev: data.data.links.prev ? true : false
                    })
                }
            })
    }
    apicall(id, contains, program) {
        console.log("awr-year " + contains)
        this.setState({
            search: contains,
            thesis: ''
        })
        this.topFunction();
        //HIDE/SHOW  previous button
        if (id <= 0) {
            this.setState({
                prev: false,
            })
        }
        else {
            this.setState({
                prev: true
            })
        }

        Axios.get(BASE + 'jsonapi/node/submit_for_work?filter[titleFilter][condition][path]=field_select_work_to_submit.name&filter[titleFilter][condition][value]=Thesis&filter[title][condition][path]=field_year&filter[title][condition][operator]=CONTAINS&filter[title][condition][value]=' + contains + '&filter[program][condition][operator]=CONTAINS&filter[program][condition][path]=field_cis_program.id&filter[program][condition][value]=' + program + '&page[limit]=' + this.state.limit + '&page[offset]=' + (id + this.state.limit) + '&sort=-created')

            .then((data) => {
                console.log(data.data, 'next')
                //HIDE/SHOW  NEXT button
                if (data.data.data.length === 0) {
                    this.setState({
                        next: false,
                    })
                }
                else {
                    this.setState({
                        next: true
                    })
                }
            })

        cachios.get(BASE + 'jsonapi/node/submit_for_work?include=field_author&filter[titleFilter][condition][path]=field_select_work_to_submit.name&filter[titleFilter][condition][value]=Thesis&filter[title][condition][path]=field_year&filter[title][condition][operator]=CONTAINS&filter[title][condition][value]=' + contains + '&filter[program][condition][operator]=CONTAINS&filter[program][condition][path]=field_cis_program.id&filter[program][condition][value]=' + program + '&page[limit]=' + this.state.limit + '&page[offset]=' + id + '&sort=-created', {
            ttl: 500 /* seconds */,
        })

            .then((datz_thesis) => {
                console.log('theses data', datz_thesis.data.data)
                this.checkexpiry()
                console.log("count of thesis", datz_thesis.data.meta.count)
                this.setState({
                    thesis: JSON.parse(datz_thesis).data.data,
                    author: datz_thesis.data.included,
                    count: datz_thesis.data.meta ? datz_thesis.data.meta.count : "",
                    coming: "coming"
                })
            })
            .catch(error => console.log(error.response));

    }
    openthesis(data) {
        console.log('thesis-pop', data)
        let i
        for (i = 0; i < this.state.thesis.length; i++) {
            this.setState({
                [i]: false
            })
        }
        this.setState({
            [data]: true
        })
    }
    clearYear() {
        for (let i = 0; i < 5; i++) {
            this.setState({
                [`yearselect${i}`]: 'year'
            })
        }
        this.setState({
            offset: 0
        })
    }
    handleChange(e, id) {

        if (e.target.value === "") {
            this.singletheses(id, 0)
        }

        console.log(e.target.value, id, 'filter')
        console.log('years', e.target.value)
        for (let i = 0; i < 5; i++) {
            if (e.target.name !== `yearselect${i}`) {
                this.setState({
                    [`yearselect${i}`]: 'year'
                })
            }
        }
        // if (e.target.value === "") {
        //     this.setState({
        //         thesis: []
        //     })
        // }
        this.setState({
            id: id,
            [e.target.name]: e.target.value,
            nidprop: '',
            yearselect: e.target.value,
            title: id
        })

        if (e.target.value !== "") {
            this.setState({
                offset: 0
            })
            this.newcall(0, e.target.value, id)
        }

        console.log(this.props.history, 'history')
        this.props.history.push('/theses')
    }
    loginTrue(e) {
        if (e == true) {

            if (this.state.link_redirect == true) {
                window.location.href = this.state.redirect_link
            }
            else if (this.state.pagination == true) {
                this.handlePageClick("next")
            }
            this.setState({
                loginpopup: false
            })
        }
    }

    allrecords() {
        this.setState({
            id: '',
            yearselect: '',
            allrecords: true
        })
        this.newcall(0, '2010', '303dc99f-0f60-4d48-944d-d0bf3bc464cd')
        this.props.history.push('/theses')

    }

    alert(id) {
        this.setState({
            allrecords: false
        })
        if (id !== this.state.id) {
            this.setState({
                id: id,
                yearselect: new Date().getFullYear()
            })
            this.newcall(0, new Date().getFullYear(), id)
            if (this.props.history.location.pathname !== '/theses')
                this.props.history.push('/theses')
        }

    }
    singletheses(id, offset) {
        let contains = ''
        this.setState({
            title: id,
            thesis: null,
            yearselect: null,
            id: id
        })
        // if search is there
        // if (search) {
        //     contains = `&filter[search][condition][operator]=CONTAINS&filter[search][condition][path]=title&filter[search][condition][value]=${search}`
        // }
        if (id)
            this.props.history.push('/theses')
        if (!id) {
            Axios.get(`${BASE}jsonapi/node/submit_for_work?include=field_author,field_institution&filter[field_cis_thesis]=1&filter[program][condition][operator]=CONTAINS&filter[program][condition][path]=field_cis_program.id&filter[program][condition][value]=303dc99f-0f60-4d48-944d-d0bf3bc464cd&filter[titleFilter][condition][path]=field_select_work_to_submit.name&filter[titleFilter][condition][value]=Thesis&page[limit]=${this.state.limit}&page[offset]=${offset}&sort=-created`)
                .then(data => {
                    console.log('sinlge', data.data)
                    this.setState({
                        thesis: data.data.data,
                        author: data.data.included,
                        count: data.data.meta ? data.data.meta.count : ""
                    }, () => {
                        this.clear()
                    })
                    if (data.data.links) {
                        this.setState({
                            next: data.data.links.next ? true : false,
                            prev: data.data.links.prev ? true : false
                        })
                    }
                })
            this.setState({
                title: '303dc99f-0f60-4d48-944d-d0bf3bc464cd'
            })
        }
        else {
            Axios.get(`${BASE}jsonapi/node/submit_for_work?include=field_author,field_institution&filter[field_cis_thesis]=1&filter[program][condition][operator]=CONTAINS&filter[program][condition][path]=field_cis_program.id&filter[program][condition][value]=${id}&filter[titleFilter][condition][path]=field_select_work_to_submit.name&filter[titleFilter][condition][value]=Thesis&page[limit]=${this.state.limit}&page[offset]=${offset}&sort=-created`)
                .then(data => {
                    console.log('sinlge', data.data)
                    this.setState({
                        thesis: data.data.data,
                        author: data.data.included,
                        count: data.data.meta ? data.data.meta.count : ""
                    })
                    if (data.data.links) {
                        this.setState({
                            next: data.data.links.next ? true : false,
                            prev: data.data.links.prev ? true : false
                        })
                    }
                })
        }
    }
    clear() {
        let i
        for (i = 0; i < this.state.thesis.length; i++) {
            this.setState({
                [i]: false
            })
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.match.params.nid)
            this.setState({
                nidprop: nextProps.match.params.nid
            })
        else
            this.setState({
                nidprop: ''
            })
    }
    componentDidUpdate(prevProps, prevState) {
        console.log("included update", prevState.author, this.state.author)
        console.log("count update", prevState.count, this.state.count)
        console.log("coming update", prevState.coming, this.state.coming)
    }
    render() {
        // if (this.state.proceed === true)
        return (
            <div className='searchpage studentthesispage'>
                {this.state.load ? <div className='loading'>
                    <img src={load} alt='load' />
                </div> : ''}
                <NewHeader />
                <div className="title-banner">
                    <h1 className="heading-one bold white-text">CIS Student Theses</h1>
                </div>
                <div className='container'>

                    <div className='listings'>{
                        // <div className='top-contents'>
                        //     <div className="crumbs"><Link to='/'>Home</Link> / <Link to='/theses'>Research</Link> / <Link to='/theses'>CIS Student Theses</Link></div>
                        //     {
                        //         // <TopBar data={'data1'} />

                        //     
                        // </div>
                        // <div className="page-title">
                        // <div className="title-wrapper">
                        // <div className="gloss_container">
                        // <h1 className="heading">CIS Student Theses</h1>
                        // {
                        //     // <div className="search_input thesis-search" style={{ alignSelf: 'center', zIndex: this.state.inputhide == true ? -1 : 0 }}>
                        //     //     <input type="text" placeholder="Search " name="search" onChange={(e) => { this.singletheses(this.state.title, e.target.value); this.search(e) }} />
                        //     //     <div className="search_logo" onClick={() => this.singletheses(this.state.title, this.state.search)}><img src={search} height="20px" /></div>
                        //     // </div>

                        // }
                        // </div>
                        // </div>
                        // </div>


                    }
                        <div className='top-contents'>
                            <div className="new-crumbs breadcrumbs gray-text"><Link to='/' className='gray-text'><img className='crumb-home' src={home} /> </Link><img className='rightarrow' src={crumbarrow} /> <Link to='/theses' className='gray-text'>Research</Link> <img className='rightarrow' src={crumbarrow} /><Link to='/theses' className='gray-text'>CIS Student Theses</Link></div>
                            {/* <TopBar data={'data1'} /> */}
                        </div>
                        {!this.state.nidprop ? <p className='these-desc text-justify'>
                            With an aim to be the leading institution in the field of Islamic Studies, the College of Islamic Studies offers six programs.
                            The multi-disciplinary programs at CIS are curated to meet the contemporary needs of the industry as well as to make the graduates ready to address the challenges of the future.
                            The programs at CIS include a PhD, a first-of-its-kind Masters of Arts in Applied Islamic Ethics along with contemporary Masters programs in Islamic Studies, Architecture, Finance and Global Affairs.
                            {/* The College offers 6 graduate programs to produce a generation
                            of Islamic Studies scholars, neoteric financial experts, social and innovative thinkers,
                            researchers, and applied specialists to illuminate Islamic thought across multiple
                            contemporary fields. This page hosts all the bibliographic information of CIS theses
                            since inception. Under a new agreement, the theses are hosted at ProQuest.
                            Hardcopies are additionally available at the CIS Library.  */}
                        </p> : ""}
                        <div className="main-content listing" style={{ display: this.state.nidprop ? 'none' : '', minHeight: '64.1vh' }}>
                            <div className="newsrea thesesrea">
                                <div className="rows" >

                                    <div>
                                        <div class="toggle-head heading-three bold blue-text">CIS Student Theses</div>
                                        <div className="theses-toggle-bar toggle-bar-one">
                                            {this.state.programs ? this.state.programs.map((program, ind) => {
                                                let name = `yearselect${ind}`
                                                if (program.attributes.name !== "CIS Faculty" && program.attributes.name !== "Non-Islamic Studies")
                                                    return (
                                                        <button className={this.state.title == program.id ? 'main-blue-text body-two theseCateBtn' : "gray-text body-two theseCateBtn"}
                                                            // onClick={() => { this.clear(); this.singletheses(program.id); this.setState({ title: program.id }); this.setState({ offset: program.id }) }}
                                                            style={{ color: this.state.title == program.id ? '#165E84' : '#3F3F46', whiteSpace: "unset" }}>
                                                            <p className='these-toggle-title' onClick={() => { this.singletheses(program.id, 0); this.clearYear() }}>{program.attributes.name}</p>
                                                            <select className="theseYear" name={name} value={this.state[name]} onChange={e => this.handleChange(e, program.id)}
                                                                style={{ backgroundImage: `url(${down})`, backgroundColor: this.state[name] == "year" ? "rgba(0, 0, 0, 0.38)" : "#2474BB" }}
                                                            >
                                                                {this.state.year.map((cc, id) => {
                                                                    return (
                                                                        <option key={id} value={cc}>{cc ? cc : 'year'}</option>
                                                                    )
                                                                })}
                                                            </select>
                                                            {
                                                                this.state.title == program.id ? <img className='toggle-arrow theses-selectArrow' src={togglearrow} /> : ""
                                                            }

                                                        </button>
                                                    )
                                            }) : ''}
                                        </div>
                                    </div>
                                    {/* LIST */}
                                    <div className='clusterGrants_table'>
                                        <table class="newTable">
                                            <tr className='clusterGrants-head'>
                                                <th>Title of Theses</th>
                                                <th className='min-wids'>Author</th>
                                            </tr>
                                            <tbody className='grants_table'>
                                                {/* {this.state.yearselect ? this.state.title ? <div className='heading2'><span>{this.state.title}</span><span>{this.state.yearselect ? '  ( ' + this.state.yearselect + ' )' : ''}</span></div> : '' : ""} */}
                                                {this.state.thesis ? this.state.thesis.length !== 0 ?
                                                    this.state.thesis.map((inst, index) => {
                                                        return (
                                                            <tr className="projectDetails-row">
                                                                <td>
                                                                    <Link to={{ pathname: '/theses/' + `${inst.attributes.drupal_internal__nid}` }} className='main-title' style={{ color: this.state[index] ? '#165E84' : '' }} onClick={() => { this.openthesis(index) }}>{inst.attributes.title}</Link>
                                                                </td>
                                                                <td className='min-wids'>
                                                                    <p className="title-author text-center" onClick={() => this.clear()}>{inst.attributes.field_student_name ? inst.attributes.field_student_name : ""}</p>
                                                                </td>
                                                                {/* {this.state[index] ?
                                                                <OutsideClickHandler
                                                                    onOutsideClick={() => {
                                                                        this.clear()
                                                                    }}
                                                                >
                                                                    <Draggable>
                                                                        <div className="thesis-open">
                                                                            <div className='open-title'>{inst ? inst.attributes.title : ''}</div>
                                                                            <div className='open-author'>{inst ? this.state.author.filter(item => item.id === inst.relationships.field_author.data[0].id)[0].attributes.title : ''}</div>
                                                                            <div className='open-author'>{inst.attributes.field_country ? ReactHtmlParser(getName(inst.attributes.field_country)) : ''}{inst ? this.state.author.filter(item => item.id === inst.relationships.field_institution.data[0].id)[0].attributes.title : ''}{inst.attributes.field_country ? ': ' : ''}{inst.attributes.field_degree ? inst.attributes.field_degree : ''} ,{inst.attributes.field_year ? inst.attributes.field_year : ''}</div>
                                                                            <p className='open-body'>{inst ? inst.attributes.body ? inst.attributes.body : '' : ''}</p>
                                                                            <Link to={{ pathname: '/theses/' + `${inst.attributes.drupal_internal__nid}` }} className='open-button-cont' onClick={() => { this.clear() }}>
                                                                                {inst ? <Link className='open-button' to={{ pathname: '/theses/' + `${inst.attributes.drupal_internal__nid}` }}>View More</Link> : ''}
                                                                            </Link>
                                                                        </div>
                                                                    </Draggable>
                                                                </OutsideClickHandler>
                                                                : ''} */}
                                                            </tr>
                                                        )
                                                    })
                                                    : <div className="nodata">No Records found</div>
                                                    : <List />
                                                }
                                            </tbody>
                                        </table>
                                        {this.state.thesis ? this.state.thesis.length !== 0 ? <div className='new-pagination'>
                                            <button disabled={!this.state.prev} onClick={() => this.handlePageClick('prev')} className='prev'>{!this.state.prev ? <img src={pagenoleft} /> : <img src={pageleft} />}</button>   <div className='pageno'>{this.state.offset ? (this.state.offset / 10) + 1 : 1}</div><span className='pagination-of'> of </span><div className='total'>{this.state.count ? Math.ceil(this.state.count / 10) : 1}</div> <button disabled={!this.state.next} onClick={() => this.handlePageClick('next')} className='next'>{this.state.next ? <img src={pageright} /> : <img src={pagenoright} />}</button>
                                        </div> : "" : ""}
                                    </div>
                                    {/* {
                                        this.state.result && (this.state.prev || this.state.next) ?
                                            <ul className="pagination">
                                                <li onClick={() => this.handlePageClick('prev')} className="previous disabled">
                                                    <a style={{ color: this.state.prev ? '#165E84 ' : '', fontWeight: this.state.prev ? '500' : '', cursor: this.state.prev ? '' : 'not-allowed' }} tabindex="0" role="button" className="prev" aria-disabled="true">Previous</a></li>
                                                <li onClick={() => this.handlePageClick('next')} className="next"><a style={{ color: this.state.next ? '#165E84 ' : '', fontWeight: this.state.next ? '500' : '', cursor: this.state.next ? '' : 'not-allowed' }} tabindex="0" role="button" aria-disabled="false">Next</a></li>

                                            </ul>

                                            : ''
                                    } */}

                                </div>
                            </div>
                        </div>
                        {this.state.nidprop ? <div className="search_block">
                            <ThesisOpen nid={this.state.nidprop} />
                        </div> : ''}
                        <div class="button-responsive">
                            <button onClick={() => this.setState({
                                fpopup: !this.state.fpopup
                            })} class="filter">Filter</button>
                            <i class="filter-icon"></i>
                        </div>
                        {/* MObile FIlter */}
                        <div className='mobile_filter' style={{ display: this.state.fpopup ? '' : 'none' }}>
                            <div className='mobile_filter_head' >
                                <div>Filters</div>
                                <div onClick={() => this.setState({
                                    fpopup: !this.state.fpopup
                                })}>X</div>
                            </div>
                            <div className="filter_block">
                                <Accordion>
                                    {this.state.programs ? this.state.programs.map((program, ind) => {
                                        return <div className="filter_container">
                                            <div className="filter_inner_wrapper">
                                                <AccordionItem expanded={program.attributes.name === "Islamic Finance and Economy" ? true : ''} onClick={() => this.alert(program.id)}>
                                                    <AccordionItemTitle className='accordion__title'>
                                                        <div className='sub'>
                                                            <div className='card-title'>{program.attributes.name}</div>
                                                            <div class="accordion__arrow" role="presentation"></div>
                                                        </div>
                                                    </AccordionItemTitle>
                                                    <AccordionItemBody>
                                                        {this.state.year.length !== 0 ?
                                                            <select className="cc_code" name="yearselect" value={this.state.yearselect} onChange={e => this.handleChange(e, program.id)} >
                                                                {this.state.year.map((cc, id) => {
                                                                    return (
                                                                        <option key={id} value={cc}>{cc ? cc : 'year'}</option>
                                                                    )
                                                                })}
                                                            </select>
                                                            : ''}
                                                    </AccordionItemBody>
                                                </AccordionItem>
                                            </div>
                                        </div>
                                    }) : ''}
                                </Accordion>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="filterfooter">
                    {<NewFooter />}
                </div>
            </div>


        )

    }

}

export default Thesis;